'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');

var _components = require('../../components');






var _constants = require('../../constants');



var _BuyMoreQuestions = require('./BuyMoreQuestions.scss');var styles = _interopRequireWildcard(_BuyMoreQuestions);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var BuyMoreQuestions = function (_Component) {_inherits(BuyMoreQuestions, _Component);function BuyMoreQuestions() {var _temp, _this, _ret;_classCallCheck(this, BuyMoreQuestions);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.hideModal = function () {_this.props.onRequestClose();
    }, _this.

    toggleModalState = function () {var
      modalType = _this.props.buyMoreQuestions.buyMoreQuestionsModalType;
      if (modalType === _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM) {
        _this.props.changeBuyMoreQuestionsModalType(
        { modalType: _constants.buyMoreQuestionsModalType.QUESTIONS_PRICING });

      } else {
        _this.props.changeBuyMoreQuestionsModalType(
        { modalType: _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM });

        setTimeout(function () {
          _reactScroll.scroller.scrollTo('buy-more-questions-type', {
            duration: 500,
            offset: 61,
            containerSelector: '.ReactModal__Content',
            smooth: true });

        });
      }
    }, _this.

    renderClientContactForm = function () {return (
        _react2.default.createElement('div', { className: styles.clientContactForm, name: 'buy-more-questions-type' },
          _react2.default.createElement(_components.ContactUsClientForm, {
            isModal: true })));}, _this.




    renderBuyAnotherCountOfQuestionsButton = function () {var _cx, _cx2;var
      modalType = _this.props.buyMoreQuestions.buyMoreQuestionsModalType;

      return (
        _react2.default.createElement('div', { className: styles.buyAnotherCountOfQuestionsWrapper },
          _react2.default.createElement('button', {
              className: (0, _classnames2.default)(
              styles.buyAnotherCountOfQuestionsButton, (_cx = {}, _cx[
              styles.showButton] = modalType !== _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM, _cx), (_cx2 = {}, _cx2[
              styles.hideButton] = modalType === _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM, _cx2)),

              onClick: _this.toggleModalState },

            _react2.default.createElement('span', null, _this.props.translate('buyAnotherQuantity')),
            _react2.default.createElement('span', { className: styles.actionIcon }, '\xA0\xA0+\xA0\xA0'))));



    }, _this.

    renderPackages = function () {return _react2.default.createElement(_components.RealtorQuestionsPackages, { handleChoosePackage: _this.props.handleChoosePackage });}, _this.

    renderModalBody = function (type) {return (
        _react2.default.createElement('div', { className: styles.buyMoreQuestionsModalBody },
          _this.renderPackages(),
          _this.renderBuyAnotherCountOfQuestionsButton(),
          type === _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM ?
          _this.renderClientContactForm() : null));}, _temp), _possibleConstructorReturn(_this, _ret);}BuyMoreQuestions.prototype.




  render = function render() {var _cx3;var
    modalType = this.props.buyMoreQuestions.buyMoreQuestionsModalType;

    return (
      _react2.default.createElement(_components.Modal, {
          isOpen: this.props.isOpen,
          onRequestClose: this.hideModal,
          className: (0, _classnames2.default)(
          styles.buyMoreQuestionsModal1, (_cx3 = {}, _cx3[
          styles.buyMoreQuestionsModal2] = modalType === _constants.buyMoreQuestionsModalType.CLIENT_INFO_FORM, _cx3)),

          isMobile: this.props.isMobile,
          translate: this.props.translate,
          isRtl: this.props.isRtl,
          plain: this.props.isMobile,
          overlayClassName: styles.buyMoreQuestionsModalOverlayClassName },

        _react2.default.createElement('div', { className: styles.buyMoreQuestionsModalContent },
          this.renderModalBody(modalType))));



  };return BuyMoreQuestions;}(_react.Component);


BuyMoreQuestions.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  buyMoreQuestions: _propTypes2.default.object,
  openBuyMoreQuestionsModal: _propTypes2.default.func,
  changeBuyMoreQuestionsModalType: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool };exports.default =


BuyMoreQuestions;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/BuyMoreQuestions/BuyMoreQuestions.js
// module id = 2953
// module chunks = 0